"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["columnStart", "columnEnd", "column", "rowStart", "rowEnd", "row", "area", "justifySelfStart", "justifySelfEnd", "justifySelfCenter", "justifySelfStretch", "justifySelf", "alignSelfStart", "alignSelfEnd", "alignSelfCenter", "alignSelfStretch", "alignSelf", "placeSelf", "style", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var overlapping_1 = require("../helpers/overlapping");

var trim_1 = require("../helpers/trim");

function GridItem(_ref) {
  var columnStart = _ref.columnStart,
      columnEnd = _ref.columnEnd,
      column = _ref.column,
      rowStart = _ref.rowStart,
      rowEnd = _ref.rowEnd,
      row = _ref.row,
      area = _ref.area,
      justifySelfStart = _ref.justifySelfStart,
      justifySelfEnd = _ref.justifySelfEnd,
      justifySelfCenter = _ref.justifySelfCenter,
      justifySelfStretch = _ref.justifySelfStretch,
      justifySelf = _ref.justifySelf,
      alignSelfStart = _ref.alignSelfStart,
      alignSelfEnd = _ref.alignSelfEnd,
      alignSelfCenter = _ref.alignSelfCenter,
      alignSelfStretch = _ref.alignSelfStretch,
      alignSelf = _ref.alignSelf,
      placeSelf = _ref.placeSelf,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var gridColumnStartStyle = react_1.default.useMemo(function () {
    return {
      gridColumnStart: columnStart
    };
  }, [columnStart]);
  var gridColumnEndStyle = react_1.default.useMemo(function () {
    return {
      gridColumnEnd: columnEnd
    };
  }, [columnEnd]);
  var gridColumnStyle = react_1.default.useMemo(function () {
    return {
      gridColumn: column
    };
  }, [column]);
  var gridRowStartStyle = react_1.default.useMemo(function () {
    return {
      gridRowStart: rowStart
    };
  }, [rowStart]);
  var gridRowEndStyle = react_1.default.useMemo(function () {
    return {
      gridRowEnd: rowEnd
    };
  }, [rowEnd]);
  var gridRowStyle = react_1.default.useMemo(function () {
    return {
      gridRow: row
    };
  }, [row]);
  var gridAreaStyle = react_1.default.useMemo(function () {
    return {
      gridArea: area
    };
  }, [area]);
  var justifySelfStyle = react_1.default.useMemo(function () {
    if (justifySelf) return {
      justifySelf: justifySelf
    };
    (0, overlapping_1.checkOverlapping)('justify-self', justifySelfStart, justifySelfEnd, justifySelfCenter, justifySelfStretch);
    var value = null;
    if (justifySelfStart) value = 'start';else if (justifySelfEnd) value = 'end';else if (justifySelfCenter) value = 'center';else if (justifySelfStretch) value = 'stretch';
    return value ? {
      justifySelf: value
    } : {};
  }, [justifySelf, justifySelfStart, justifySelfEnd, justifySelfCenter, justifySelfStretch]);
  var alignSelfStyle = react_1.default.useMemo(function () {
    if (alignSelf) return {
      alignSelf: alignSelf
    };
    (0, overlapping_1.checkOverlapping)('align-self', alignSelfStart, alignSelfEnd, alignSelfCenter, alignSelfStretch);
    var value = null;
    if (alignSelfStart) value = 'start';else if (alignSelfEnd) value = 'end';else if (alignSelfCenter) value = 'center';else if (alignSelfStretch) value = 'stretch';
    return value ? {
      alignSelf: value
    } : {};
  }, [alignSelf, alignSelfStart, alignSelfEnd, alignSelfCenter, alignSelfStretch]);
  var placeSelfStyle = react_1.default.useMemo(function () {
    return {
      placeSelf: placeSelf
    };
  }, [placeSelf]);
  var combinedStyle = (0, trim_1.trimUndefined)(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, gridColumnStartStyle), gridColumnEndStyle), gridColumnStyle), gridRowStartStyle), gridRowEndStyle), gridRowStyle), gridAreaStyle), justifySelfStyle), alignSelfStyle), placeSelfStyle), style));
  return react_1.default.createElement("div", _objectSpread({
    style: combinedStyle
  }, rest), children);
}

exports.default = GridItem;